import 'prismjs'
import 'prismjs/themes/prism.css'

import VuePrism from 'vue-prism'
import Vue from 'vue'

Vue.use(VuePrism)
